// eslint-disable-next-line
export default {
    name: "Recipes",
    status: {
        router: true,
        redux: true
    }
}
